import React from 'react';

const Error = ({message}) => <p>Error: {message}. Please try again later.</p>;

export default Error;
